import React from 'react';
import { ChecklistCard, ChecklistItem } from './ChecklistCard';
import { TaskPreviewCard } from './TaskPreviewCard';
import { MultipleChoiceWidget } from './widgets/MultipleChoiceWidget';
import { DatePickerWidget } from './widgets/DatePickerWidget';
import { PriorityWidget } from './widgets/PriorityWidget';
import { TextInputWidget } from './widgets/TextInputWidget';
export interface MessageShortcut {
  label: string;
  prompt: string;
}
export interface Message {
  id: string;
  type: 'user' | 'assistant';
  content: string;
  checklist?: {
    title: string;
    items: ChecklistItem[];
  };
  widget?: {
    type: 'multipleChoice' | 'datePicker' | 'priority' | 'textInput';
    question: string;
    options?: any[];
    placeholder?: string;
    optional?: boolean;
  };
  shortcuts?: MessageShortcut[];
  categoryColor?: string;
  timestamp: Date;
}
interface MessageBubbleProps {
  message: Message;
  onPreviewClick?: (checklist: {
    title: string;
    items: ChecklistItem[];
  }) => void;
  onWidgetResponse?: (response: string) => void;
  onWidgetSkip?: () => void;
  onShortcutClick?: (prompt: string) => void;
}
export function MessageBubble({
  message,
  onPreviewClick,
  onWidgetResponse,
  onWidgetSkip,
  onShortcutClick
}: MessageBubbleProps) {
  const isUser = message.type === 'user';
  return <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`} data-id="element-167">
      <div className={`max-w-[85%] ${isUser ? 'max-w-[80%]' : ''}`} data-id="element-168">
        <div className={`
            px-4 py-3 rounded-yeppy font-poppins text-[15px] leading-relaxed
            ${isUser ? 'text-yeppy-text rounded-br-none' : 'bg-white border border-yeppy-text border-opacity-10 text-yeppy-text rounded-bl-none'}
          `} style={isUser ? {
        backgroundColor: '#1D2A36',
        color: '#FFFFFB'
      } : undefined} data-id="element-169">
          {message.content}
        </div>

        {/* Render widget if present and not user */}
        {message.widget && !isUser && onWidgetResponse && <div className="mt-2" data-id="element-170">
            {message.widget.type === 'multipleChoice' && <MultipleChoiceWidget question={message.widget.question} options={message.widget.options || []} onSelect={onWidgetResponse} data-id="element-171" />}
            {message.widget.type === 'datePicker' && <DatePickerWidget question={message.widget.question} onSubmit={onWidgetResponse} onSkip={onWidgetSkip || (() => {})} data-id="element-172" />}
            {message.widget.type === 'priority' && <PriorityWidget question={message.widget.question} onSelect={onWidgetResponse} data-id="element-173" />}
            {message.widget.type === 'textInput' && <TextInputWidget question={message.widget.question} placeholder={message.widget.placeholder} optional={message.widget.optional} onSubmit={onWidgetResponse} onSkip={message.widget.optional ? onWidgetSkip : undefined} data-id="element-174" />}
          </div>}

        {/* Render checklist preview if present and not user */}
        {message.checklist && !isUser && <TaskPreviewCard taskCount={message.checklist.items.length} title={message.checklist.title} onClick={() => onPreviewClick?.(message.checklist!)} categoryColor={message.categoryColor} data-id="element-175" />}

        {/* Render shortcuts if present */}
        {message.shortcuts && message.shortcuts.length > 0 && !isUser && onShortcutClick && <div className="mt-3 flex flex-wrap gap-2" data-id="element-176">
              {message.shortcuts.map((shortcut, idx) => <button key={idx} onClick={() => onShortcutClick(shortcut.prompt)} className="px-3 py-2 rounded-2xl font-poppins text-xs text-yeppy-text bg-white border border-yeppy-text border-opacity-10 transition-all active:scale-95 hover:border-opacity-20 text-left" data-id="element-177">
                  {shortcut.label}
                </button>)}
            </div>}

        {/* Timestamp */}
        <div className={`mt-1 px-1 text-xs font-poppins text-yeppy-text text-opacity-40 ${isUser ? 'text-right' : 'text-left'}`} data-id="element-178">
          {message.timestamp.toLocaleTimeString('it-IT', {
          hour: '2-digit',
          minute: '2-digit'
        })}
        </div>
      </div>
    </div>;
}